import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DocLimitModalComponent } from "./doc-limit-modal/doc-limit-modal.component";
import { MaterialModule } from "src/app/material/material.module";

@NgModule({
  declarations: [DocLimitModalComponent],
  imports: [CommonModule, MaterialModule],
})
export class ModalModule {}
